import GhrLogoUrl from './assets/ghr/logo.svg'
import EducationLogoUrl from './assets/education/logo.svg'
import PlanetLogoUrl from './assets/planet/logo.svg'
import UnitedAnesthesiaLogoUrl from './assets/united-anesthesia/logo.svg'
import GhrBannerUrl from './assets/ghr/banner.png'
import EducationBannerUrl from './assets/education/banner.png'
import PlanetBannerUrl from './assets/planet/banner.png'
import UnitedAnesthesiaBannerUrl from './assets/united-anesthesia/banner.png'

import GhrAnoBannerUrl from './assets/ghr/ano-banner.png'
import EducationAnoBannerUrl from './assets/education/ano-banner.png'
import PlanetAnoBannerUrl from './assets/planet/ano-banner.png'
import UnitedAnesthesiaAnoBannerUrl from './assets/united-anesthesia/ano-banner.png'

// Logo URLs
export const LOGO_URLS = {
	ghr: GhrLogoUrl,
	education: EducationLogoUrl,
	planet: PlanetLogoUrl,
	unitedAnesthesia: UnitedAnesthesiaLogoUrl,
}

// Banner URLs
export const BANNER_URLS = {
	ghr: GhrBannerUrl,
	education: EducationBannerUrl,
	planet: PlanetBannerUrl,
	unitedAnesthesia: UnitedAnesthesiaBannerUrl,
}

// Anonymous Banner URLs
export const ANO_BANNER_URLS = {
	ghr: GhrAnoBannerUrl,
	education: EducationAnoBannerUrl,
	planet: PlanetAnoBannerUrl,
	unitedAnesthesia: UnitedAnesthesiaAnoBannerUrl,
}

export const DEFAULT_LOGO = LOGO_URLS.ghr
export const DEFAULT_BANNER = BANNER_URLS.ghr
export const DEFAULT_ANO_BANNER = ANO_BANNER_URLS.ghr
